import axios from "axios";
import { TokenService } from './storage';

// for parsing query array
// e.g, ?test[]=1&test[]=2
// become ?test=1&test=2
const transformRequestOptions = params => {
  let options = '';
  for (const key in params) {
  if (typeof params[key] !== 'object' && params[key]) {
    options += `${key}=${params[key]}&`;
  } else if (typeof params[key] === 'object' && params[key] && params[key].length) {
      params[key].forEach(el => {
          options += `${key}=${el}&`;
   });
  }
}
return options ? options.slice(0, -1) : options;
};

const apiService = {
  init(baseURL) {
    console.log("BASE URL : ",baseURL)
    axios.defaults.baseURL = baseURL;
  },

  setHeader() {
    axios.defaults.headers.common.Authorization = `Bearer ${TokenService.getToken()}`;
  },

  removeHeader() {
    axios.defaults.headers.common = {};
  },

  get(resource,param,options) {
    let payload = {
      params : param,
    }
    if(options?.parseArray){
      payload.paramsSerializer= params => transformRequestOptions(params) 
    }
    return axios.get(resource, payload);
  },

  post(resource, data) {
    return axios.post(resource, data);
  },

  put(resource, data) {
    return axios.put(resource, data);
  },

  delete(resource, data) {
    return axios.delete(resource, data);
  },

  customRequest(data) {
    return axios(data);
  },
};

export default apiService;